import { css } from "@emotion/react";
import styled from "@emotion/styled/macro";
import { Icon } from "@material-ui/core";
import { ArrowDropDown } from "@material-ui/icons";

import { StyledCompProps } from "../../../../../../../globalTypes/theme";

export const ModuleName = styled.span`
  margin-left: 5px;
  color: rgb(192, 198, 208);

  white-space: nowrap;

  @media (max-width: 812px) {
    color: ${({ theme }) => theme.colors.secondaryColor};
    font-size: 18px;
  }
`;

export const ModuleIcon = styled(Icon)<StyledCompProps>`
  color: rgb(192, 198, 208);
  @media (max-width: 812px) {
    color: ${({ theme }) => theme.colors.secondaryColor};
    font-size: 24px;
  }
`;

export const ArrowDown = styled(ArrowDropDown)`
  color: rgb(192, 198, 208);
  margin-left: 0.1rem;

  font-size: 1.5rem;
`;

export const notificationIndicatorCss = css`
  position: absolute;
  top: 0.5rem;
  right: 0;

  @media (max-width: 812px) {
    top: 0;
    right: 8px;
  }
`;

export const RelativeContainer = styled.li`
  position: relative;
  list-style: none;
`;

const navItemStylesCss = css`
  width: 100vw;
  padding: 0.5rem 1rem;
  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;

  // -1px is bcs parent border bottom overflow
  height: calc(4.5rem - 1px);
  background-color: #fff;
  text-decoration: none;

  @media only screen and (min-width: 813px) {
    width: auto;
  }
`;

export const Module = styled("a", {
  shouldForwardProp: (prop) => prop !== "isToggled",
})<{ isToggled: boolean }>`
  ${navItemStylesCss};

  border-top: 1px solid rgb(231, 232, 236);

  &:last-of-type {
    border-bottom: 1px solid rgb(231, 232, 236);
  }

  @media only screen and (min-width: 813px) {
    border: none;
    cursor: pointer;

    ${({ isToggled, theme }) =>
      isToggled &&
      `
        ${ModuleName} {
          color: ${theme.colors.primaryColor};
        }

        ${ArrowDown} {
          color: ${theme.colors.primaryColor};
        }

        ${ModuleIcon} {
          color: ${theme.colors.primaryColor};
        }
      `}

    &:hover {
      ${ModuleName} {
        color: ${({ theme }) => theme.colors.primaryColor};
      }

      ${ArrowDown} {
        color: ${({ theme }) => theme.colors.primaryColor};
      }
    }

    &:last-of-type {
      border-bottom: none;
    }
  }
`;

export const TemplateCollapse = styled.ul`
  width: 100vw;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;

  @media only screen and (min-width: 813px) {
    position: absolute;
    width: auto;
    top: 101%;
    left: 0;
    min-width: 15rem;
    max-height: calc(100vh - 4.6rem);
    overflow-y: auto;
    border-radius: 0.4rem;
  }
`;
